import React, { useCallback } from "react";
import { Field, useFormikContext } from "formik";
import styled from "styled-components";
import { FormGroup } from "components/bootstrap";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import { Select, Icon, Spinner } from "components/common";
import useUpdateTableFilter from "data-lake/preview/storage-types/external/hooks/useUpdateTableFilter";
const Container = styled(FormGroup)`
  flex: 1;
`;
const placeholder = "Select the table you want to preview logs for";
const TableFilter = ({ tables, isLoading, hasOnlyOneCatalog }) => {
  const { dataLakeFieldsFetchQuery } = useSelectedDataLake();
  const { setFieldValue } = useFormikContext();
  const updateTableFilter = useUpdateTableFilter(setFieldValue);
  const onChange = useCallback(
    (newTable) => {
      updateTableFilter(newTable);
    },
    [updateTableFilter]
  );
  const renderOption = useCallback(
    (option) => {
      if (hasOnlyOneCatalog) {
        return /* @__PURE__ */ React.createElement(React.Fragment, null, option.label);
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, option.catalog, " ", /* @__PURE__ */ React.createElement(Icon, { name: "chevron_right" }), " ", option.schema, " ", /* @__PURE__ */ React.createElement(Icon, { name: "chevron_right" }), " ", /* @__PURE__ */ React.createElement("b", null, option.label));
    },
    [hasOnlyOneCatalog]
  );
  return /* @__PURE__ */ React.createElement(Field, { name: "table", value: dataLakeFieldsFetchQuery == null ? void 0 : dataLakeFieldsFetchQuery.tableId }, ({ meta: { error }, field: { value } }) => /* @__PURE__ */ React.createElement(Container, { "data-testid": "table-filter", validationState: error ? "error" : void 0, bsClass: "no-bm" }, isLoading ? /* @__PURE__ */ React.createElement(Spinner, { text: "Loading tables..." }) : /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder,
      displayKey: "key",
      inputId: "table-filter",
      value,
      optionRenderer: renderOption,
      options: tables,
      multi: false,
      onChange
    }
  )));
};
export default TableFilter;
